/**
 * @generated SignedSource<<61eff32cabf0770573f3bbab87d15e9c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useExposedReturnsClientVariant_viewer$data = {
  readonly user?: {
    readonly isVerifiedTrade: boolean | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"useEuEligible_viewer">;
  readonly " $fragmentType": "useExposedReturnsClientVariant_viewer";
};
export type useExposedReturnsClientVariant_viewer$key = {
  readonly " $data"?: useExposedReturnsClientVariant_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"useExposedReturnsClientVariant_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useExposedReturnsClientVariant_viewer",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        }
      ],
      "kind": "FragmentSpread",
      "name": "useEuEligible_viewer"
    },
    {
      "condition": "fetchUser",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isVerifiedTrade",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "cf92ec3b313cb8cc34590997137ae820";

export default node;
